{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Aðgangs stillingar",
    "SUBMIT": "Uppfæra stillingar",
    "BACK": "Til baka",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Gat ekki uppfært stillingar, reyndu aftur!",
      "SUCCESS": "Tókst að uppfæra stillingar"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Eyða",
        "DISMISS": "Hætta við",
        "PLACE_HOLDER": "Please type {accountName} to confirm"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Vinsamlegast lagfærðu villurnar",
      "GENERAL_SECTION": {
        "TITLE": "Almennar stillingar",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Númer aðgangs",
        "NOTE": "Þetta auðkenni er nauðsynlegt ef þú ert að byggja upp API byggða samþættingu"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferences",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Aðgangsnafn",
        "PLACEHOLDER": "Þitt aðgangsnafn",
        "ERROR": "Vinsamlegast sláðu inn samþykkt aðgangsnafn"
      },
      "LANGUAGE": {
        "LABEL": "Tungumál síðu",
        "PLACEHOLDER": "Þitt aðgangsnafn",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "Lénið þar sem þú færð tölvupóstinn",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Þjónustu tölvupóstur",
        "PLACEHOLDER": "Þjónustu tölvupóstur fyrirtækisins",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Uppfæra",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Samfellu samtals með tölvupósti er virkjuð fyrir reikninginn þinn.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Þú getur fengið tölvupóst á þitt lén núna."
      }
    },
    "UPDATE_CHATWOOT": "Uppfærsla {latestChatwootVersion} fyrir Chatwoot er fáanleg. Vinsamlegast uppfærðu tilvikið þitt.",
    "LEARN_MORE": "Læra meira",
    "PAYMENT_PENDING": "Your payment is pending. Please update your payment information to continue using Chatwoot",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "Your account has exceeded the usage limits, please upgrade your plan to continue using Chatwoot",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Enter til þess að velja",
      "ENTER_TO_REMOVE": "Enter til þess að fjarlægja",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Veldu eitt",
      "SELECT": "Velja"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Skilaboð",
    "MARK_ALL_DONE": "Merkja allt tilbúð",
    "DELETE_TITLE": "eyða",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Ólesnar tilkynningar",
      "ALL_NOTIFICATIONS": "Skoða allar tilkynningar",
      "LOADING_UNREAD_MESSAGE": "Hleð ólesnum skilaboðum...",
      "EMPTY_MESSAGE": "Þú átt enginn ólesin skilaboð"
    },
    "LIST": {
      "LOADING_MESSAGE": "Hleð skilaboðum...",
      "404": "Engin skilaboð",
      "TABLE_HEADER": [
        "Nafn",
        "Símanúmer",
        "Samtöl",
        "Síðast samband"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nýtt samtal",
      "conversation_assignment": "Samtali úthlutað",
      "assigned_conversation_new_message": "Nýtt skilaboð",
      "participating_conversation_new_message": "Nýtt skilaboð",
      "conversation_mention": "Nefna",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Uppfæra"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Leita eða stökkva til",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Almennar",
      "REPORTS": "Skýrslur",
      "CONVERSATION": "Samtal",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Breyta úthlutun",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Breyta Teymi",
      "SNOOZE_CONVERSATION": "Fresta Samtali",
      "ADD_LABEL": "Merkja samtalið",
      "REMOVE_LABEL": "Fjarlægja merki af samtali",
      "SETTINGS": "Stillingar",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Opna Stjórnborð Samtals",
      "GO_TO_CONTACTS_DASHBOARD": "Opna Stjórnborð Tengiliða",
      "GO_TO_REPORTS_OVERVIEW": "Opna yfirlit Skýrslna",
      "GO_TO_CONVERSATION_REPORTS": "Opna Samtals Skýrslur",
      "GO_TO_AGENT_REPORTS": "Opna Þjónustufulltrúa Skýrslur",
      "GO_TO_LABEL_REPORTS": "Opna Merkja Skýrslur",
      "GO_TO_INBOX_REPORTS": "Opna Innhólfs Skýrslur",
      "GO_TO_TEAM_REPORTS": "Opna Teymis Skýrslur",
      "GO_TO_SETTINGS_AGENTS": "Opna Stillingar Þjónustufulltrúa",
      "GO_TO_SETTINGS_TEAMS": "Opna Stillingar Teymis",
      "GO_TO_SETTINGS_INBOXES": "Opna Stillingar Innhólfs",
      "GO_TO_SETTINGS_LABELS": "Opna Stillingar Merkja",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Opna Stillingar Staðlaðra Svara",
      "GO_TO_SETTINGS_APPLICATIONS": "Opna Stillingar Forrits",
      "GO_TO_SETTINGS_ACCOUNT": "Opna Stillingar Aðgangs",
      "GO_TO_SETTINGS_PROFILE": "Opna Stillingar Prófíls",
      "GO_TO_NOTIFICATIONS": "Opna Tilkynningar",
      "ADD_LABELS_TO_CONVERSATION": "Merkja samtalið",
      "ASSIGN_AN_AGENT": "Úthluta á þjónustufulltrúa",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Úthluta á teymi",
      "MUTE_CONVERSATION": "Þagga samtal",
      "UNMUTE_CONVERSATION": "Afþagga samtal",
      "REMOVE_LABEL_FROM_CONVERSATION": "Fjarlægja merki af samtali",
      "REOPEN_CONVERSATION": "Enduropna samtal",
      "RESOLVE_CONVERSATION": "Leysa samtal",
      "SEND_TRANSCRIPT": "Senda afrit með tölvupósti",
      "SNOOZE_CONVERSATION": "Fresta Samtali",
      "UNTIL_NEXT_REPLY": "Þar til að næsta svar berst",
      "UNTIL_NEXT_WEEK": "Þar til í næstu viku",
      "UNTIL_TOMORROW": "Þar til á morgun",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Hleð Stjórnborði..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "smelltu hér"
  }
}
